import React from 'react';
import LoadingIndicator from './LoadingIndicator';

export function SidebarIcon({ type }) {
  const common = {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': 'true',
  };

  switch (type) {
    case 'dashboard':
      return (
        <svg {...common}>
          <rect x="4" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
          <rect x="13" y="4" width="7" height="4" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
          <rect x="13" y="10" width="7" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
          <rect x="4" y="13" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
        </svg>
      );
    case 'tasks':
      return (
        <svg {...common}>
          <rect x="4" y="5" width="16" height="14" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
          <path d="M8 9h8M8 13h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M6.5 9l1 1 1.5-1.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'team':
      return (
        <svg {...common}>
          <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="17" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.8" />
          <path d="M3.5 19a5.5 5.5 0 0 1 11 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M13.5 19a4.5 4.5 0 0 1 7 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case 'reporting':
      return (
        <svg {...common}>
          <path d="M4 19h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M6 16V10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M11 16V6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M16 16v-7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case 'settings':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
          <path
            d="M19.4 13a7.9 7.9 0 0 0 .1-2l2-1.2-2-3.4-2.2.7a8 8 0 0 0-1.7-1l-.3-2.3H10l-.3 2.3a8 8 0 0 0-1.7 1L5.8 6.4l-2 3.4L5.8 11a7.9 7.9 0 0 0 0 2l-2 1.2 2 3.4 2.2-.7a8 8 0 0 0 1.7 1l.3 2.3h5.2l.3-2.3a8 8 0 0 0 1.7-1l2.2.7 2-3.4z"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinejoin="round"
          />
        </svg>
      );
    default:
      return null;
  }
}

export function LogoutIcon({ size = 16, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ display: 'inline-block', verticalAlign: 'middle', paddingLeft: 1, marginRight: 8, ...(style || {}) }}
    >
      <rect width="16" height="16" fill="none" />
      <path d="M14,14l0,-12l-6,0l0,-2l8,0l0,16l-8,0l0,-2l6,0Zm-9.002,-0.998l-4.998,-5.002l5,-5l1.416,1.416l-2.588,2.584l8.172,0l0,2l-8.172,0l2.586,2.586l-1.416,1.416Z" />
    </svg>
  );
}

export function SupportIcon({ size = 20, color = 'currentColor', style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ display: 'inline-block', marginRight: 8, verticalAlign: 'middle', ...(style || {}) }}
    >
      <path
        fillRule="evenodd"
        d="M0 10C0 4.478 4.478 0 10 0c5.523 0 10 4.478 10 10 0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10zm11.125 2.002H8.989v-.141c.01-1.966.492-2.254 1.374-2.782.093-.056.19-.114.293-.178.73-.459 1.292-1.038 1.292-1.883 0-.948-.743-1.564-1.666-1.564-.851 0-1.657.398-1.712 1.533H6.304C6.364 4.693 8.18 3.5 10.294 3.5c2.306 0 3.894 1.447 3.894 3.488 0 1.382-.695 2.288-1.805 2.952l-.238.144c-.79.475-1.009.607-1.02 1.777V12zm.17 3.012a1.344 1.344 0 01-1.327 1.328 1.32 1.32 0 01-1.328-1.328 1.318 1.318 0 011.328-1.316c.712 0 1.322.592 1.328 1.316z"
        fill={color}
      />
    </svg>
  );
}

function isAdminUser(user) {
  const role = String(user?.role || '').toLowerCase();
  return Number(user?.role) === 1 || Number(user?.role) === 2 || role === 'admin' || role === 'mis';
}

function NavButton({ id, active, title, icon, onClick }) {
  return (
    <button
      className={`sidebar-item ${active === id ? 'active' : ''}`}
      title={title}
      onClick={onClick}
      type="button"
    >
      <SidebarIcon type={icon} />
      <span>{title}</span>
    </button>
  );
}

export default function AppSidebar({
  user,
  active,
  onLogout,
  loggingOut,
  onCreateTask,
  onNavigateToDashboard,
  onNavigateToTasks,
  onNavigateToFMS,
  onNavigateToReturns,
  onNavigateToDelegation,
  onNavigateToAllTasks,
  onNavigateToResourceControl,
  onNavigateToLogging,
}) {
  const canAdmin = isAdminUser(user);
  const navigation = {
    dashboard: onNavigateToDashboard,
    tasks: onNavigateToTasks,
    fms: onNavigateToFMS,
    returns: onNavigateToReturns,
    delegation: onNavigateToDelegation,
    allTasks: onNavigateToAllTasks,
    resourceControl: onNavigateToResourceControl,
    logging: onNavigateToLogging,
  };

  return (
    <aside className="sidebar fms-sidebar">
      <div>
        <div className="sidebar-brand fms-sidebar-brand">
          <div className="sidebar-logo fms-sidebar-logo">
            <img src="/assets/karban_logo.png" alt="Karban" />
          </div>
          <div className="fms-sidebar-brand-copy">
            <p>TaskMaster</p>
          </div>
        </div>

        <nav className="sidebar-nav">
          {canAdmin && onCreateTask ? (
            <button className="create-task-btn" type="button" onClick={onCreateTask}>
              + Create Task
            </button>
          ) : null}

          <span className="fms-sidebar-section-label">Workspace</span>
          <NavButton id="dashboard" active={active} title="Dashboard" icon="dashboard" onClick={navigation.dashboard} />
          <NavButton id="tasks" active={active} title="Tasks" icon="tasks" onClick={navigation.tasks} />
          <NavButton id="fms" active={active} title="FMS Dashboard" icon="dashboard" onClick={navigation.fms} />
          <NavButton id="returns" active={active} title="Return FMS" icon="dashboard" onClick={navigation.returns} />
          <NavButton id="delegation" active={active} title="Delegation Tasks" icon="tasks" onClick={navigation.delegation} />
          <NavButton id="allTasks" active={active} title="All Tasks" icon="reporting" onClick={navigation.allTasks} />
          {canAdmin ? (
            <NavButton id="logging" active={active} title="Logging" icon="reporting" onClick={navigation.logging} />
          ) : null}
          {canAdmin ? (
            <NavButton id="resourceControl" active={active} title="Resource Control" icon="settings" onClick={navigation.resourceControl} />
          ) : null}
          <NavButton id="team" active={active} title="Team" icon="team" />
          <NavButton id="reporting" active={active} title="Reporting" icon="reporting" />
          <NavButton id="settings" active={active} title="Settings" icon="settings" />
        </nav>
      </div>

      <div className="sidebar-bottom">
        <span className="fms-sidebar-section-label">Account</span>
        <button className="sidebar-item" title="Support" type="button">
          <SupportIcon size={16} style={{ marginRight: 0 }} />
          <span>Support</span>
        </button>
        <button className="sidebar-item" title="Logout" onClick={onLogout} disabled={loggingOut} type="button">
          {loggingOut ? (
            <LoadingIndicator variant="button" label="Logging out..." />
          ) : (
            <>
              <LogoutIcon size={16} style={{ marginRight: 0 }} />
              <span>Logout</span>
            </>
          )}
        </button>
      </div>
    </aside>
  );
}
